import React from 'react'

export default () => {
  return (
    <div>
        <h2>Your dizziness is most likely caused by   <strong className="text-decoration" data-tip="A condition in which blood pressure falls significantly upon quickly standing up, often accompanied by a faint or dizzy feeling">Orthostatic Hypotension (OH)</strong> </h2>
        <p>Mild OH is fairly common and can occur in nearly anyone. The most common cause is Dehydration, so drinking water or replenishing electrolytes with a sports drink should help alleviate the problem.</p>
        <p>If your dizziness is causing significant difficulty in your life, more dangerous symptoms like fainting or falls, or doesn't seem to be related to dehydration, be sure to visit your primary care doctor to find out what treatments might be best for you.</p>
        <a id="OH" href="https://www.rehabmart.com/post/why-am-i-dizzy-top-5-causes-of-dizziness-what-to-do" target="_black">read more about this condition ></a>
    </div>
  )
}
